import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { InfoIconComponent } from '../icons/info-icon.component';

@Component({
  selector: 'app-confirmation-dialog',
  template: `
    <h1 mat-dialog-title class="!mt-3 !flex items-center gap-2">
      <app-info-icon
        *ngIf="data.showInfoIcon"
        size="28"
        customClass="text-blue-600 flex-shrink-0"
      ></app-info-icon>
      <span>{{ data.title }}</span>
    </h1>
    <div mat-dialog-content>
      <p style="white-space: pre-line;">{{ data.description }}</p>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()">{{ data.cancelText ?? 'Cancelar' }}</button>
      <button mat-flat-button color="primary" (click)="onConfirm()">{{ data.confirmText ?? 'Confirmar' }}</button>
    </div>
  `,
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, InfoIconComponent]
})
export class ConfirmationDialogComponent {
  constructor(
    private _dialogRef: MatDialogRef<ConfirmationDialogComponent>, // Generated by Copilot
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      description?: string;
      confirmText?: string;
      cancelText?: string;
      showInfoIcon?: boolean;
    } // Generated by Copilot
  ) {}

  onConfirm(): void {
    this._dialogRef.close(true); // Generated by Copilot
  }

  onCancel(): void {
    this._dialogRef.close(false); // Generated by Copilot
  }
}
